import React from 'react';
import ProfileMenu from './ProfileMenu';
import { connect } from 'react-redux';
import { getSelectedLanguage, languageOptions, setSelectedLanguage } from '../language';


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedLanguage: getSelectedLanguage()
        };
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleLanguageEvent = this.handleLanguageEvent.bind(this);
    }

    componentDidMount() {
        window.addEventListener('candidate_language_change', this.handleLanguageEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('candidate_language_change', this.handleLanguageEvent);
    }

    handleLanguageEvent(event) {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    handleLanguageChange(event) {
        this.setState({ selectedLanguage: setSelectedLanguage(event.target.value) });
    }

    render() {
        return (
            <div className="topbar">

                <div className="topbar-left">
                    {this.props.faculdade.logo != null && <a className="logo">
                        <img src={this.props.faculdade.logo} alt={this.props.faculdade.name || "Instituição"} />
                    </a>}
                </div>
                <nav className="navbar-custom">
                    <ul className="navbar-right d-flex list-inline float-right mb-0">
                        <li className="candidate-header-language">
                            <i className="mdi mdi-web"></i>
                            <select value={this.state.selectedLanguage} onChange={this.handleLanguageChange}>
                                {languageOptions.map((item) => (
                                    <option key={item.value} value={item.value}>{item.value}</option>
                                ))}
                            </select>
                        </li>
                        <ProfileMenu />


                    </ul>



                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade
    }
);

export default connect(mapsStateToProps, {})(Header);
